import { alertAuthExpired, fetchFfdJson } from "shared/api/ffdClient";

export const fetchStudyStop = async (
  authToken: string,
  name: string
): Promise<void> => {
  try {
    const { data } = await fetchFfdJson<{ text?: string }>(
      `/studies/stop?study_name=${encodeURIComponent(name)}`,
      authToken
    );
    if (data.text) alert(data.text);
  } catch (error) {
    alertAuthExpired();
  }
};
